import styled, { css, keyframes } from 'styled-components';

const backgroundZoom = keyframes`
  0%, 100% {
    transform: scale(1);
  }

  40% {
    transform: scale(1.15);
  }
`;

const zoomAnimation = css`
  animation: ${backgroundZoom} 12s ease-in-out infinite;
  will-change: transform;
`;

export const ScBackgroundImage = styled.div<{ $disableAnimation?: boolean }>`
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;

  .bgLayer {
    position: absolute;
    inset: 0;
    ${({ $disableAnimation }) => !$disableAnimation && zoomAnimation}
  }

  .bg {
    object-fit: cover;
  }

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 80px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 100%);
  }
`;
